module.exports = __webpack_public_path__ + "media/images/front/banner_premium_side-02c5370d49acf8a33f2aa21f86d2e815.jpg";